module.exports = __webpack_public_path__ + "static/media/steps.c1d8d0ed.svg";